// Função utilitária para verificar se o valor possui sequência numérica crescente ou decrescente de qualquer tamanho
function isSequenciaNumerica(val: string, length: number): boolean {
  if (val.length < length) return false;
  // Gera sequências crescentes e decrescentes para o tamanho informado
  const baseCrescente = "01234567890".repeat(2);
  const baseDecrescente = "9876543210".repeat(2);
  for (let i = 0; i <= baseCrescente.length - length; i++) {
    const seqCresc = baseCrescente.slice(i, i + length);
    const seqDecresc = baseDecrescente.slice(i, i + length);
    if (val === seqCresc || val === seqDecresc) {
      return true;
    }
  }
  return false;
}

// Função utilitária para verificar se todos os caracteres de um valor são repetidos em um determinado length
function hasRepeatedChars(val: string, length: number): boolean {
  if (val.length < length) return false;
  const char = val[0];
  for (let i = 1; i < length; i++) {
    if (val[i] !== char) return false;
  }
  return true;
}

function replaceNonNumericChars(val: string): string {
  return val.replace(/\D/g, "");
}

// Função para validar CPF
function isValidCPF(cpf: string): boolean {
  const cleanCPF = replaceNonNumericChars(cpf);

  if (cleanCPF.length !== 11) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cleanCPF)) return false;

  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
  }
  let digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleanCPF.charAt(9))) return false;

  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
  }
  digit = 11 - (sum % 11);
  if (digit >= 10) digit = 0;
  if (digit !== parseInt(cleanCPF.charAt(10))) return false;

  return true;
}

// Função para validar CNPJ
function isValidCNPJ(cnpj: string): boolean {
  const cleanCNPJ = replaceNonNumericChars(cnpj);

  if (cleanCNPJ.length !== 14) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(cleanCNPJ)) return false;

  // Validação do primeiro dígito verificador
  let sum = 0;
  let weight = 5;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cleanCNPJ.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (digit !== parseInt(cleanCNPJ.charAt(12))) return false;

  // Validação do segundo dígito verificador
  sum = 0;
  weight = 6;
  for (let i = 0; i < 13; i++) {
    sum += parseInt(cleanCNPJ.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (digit !== parseInt(cleanCNPJ.charAt(13))) return false;

  return true;
}

// Função para validar CPF ou CNPJ
function isValidCPFOrCNPJ(value: string): boolean {
  const cleanValue = replaceNonNumericChars(value);

  if (cleanValue.length === 11) {
    return isValidCPF(value);
  } else if (cleanValue.length === 14) {
    return isValidCNPJ(value);
  }

  return false;
}

export { hasRepeatedChars, isSequenciaNumerica, isValidCNPJ, isValidCPF, isValidCPFOrCNPJ, replaceNonNumericChars };
